import Mutations from '../../odata/mutations';

export default { ...new Mutations('rateSchedule'), ...new Mutations('rateSchedules') };
